// extracted by mini-css-extract-plugin
export default {"informationView":"YpOfrdbiCxe4N9xhcQIp","title":"K5xFqgVHl0VWj9cgzd9A","description":"suUzBNsQ5aRlUufULwCL","footer":"ezBGRZuG1OQNbu0pzd38"};